//  Copyright (c) 2020 First Foundry Inc. All rights reserved.

import {
  SET_PAGE,
  SET_SEARCH_TERM,
  SET_FILTERS,
  SET_SORT,
  SET_RESULT,
} from './actionTypes'

export const setPage = ({ page }) => ({
  type: SET_PAGE,
  payload: {
    page,
  },
})

export const setSearchTerm = ({ searchTerm }) => ({
  type: SET_SEARCH_TERM,
  payload: {
    searchTerm,
  },
})

export const setFilters = ({ filters }) => ({
  type: SET_FILTERS,
  payload: {
    filters,
  },
})

export const setSort = ({ sort }) => ({
  type: SET_SORT,
  payload: {
    sort,
  },
})

export const setResult = ({ result }) => ({
  type: SET_RESULT,
  payload: {
    result,
  },
})
